import React from 'react';
import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { isRelationshipToVeteran } from '../../../../utils/helpers';
import content from '../../../../utils/content.json';

const LandAffect = () => (
  <va-additional-info trigger="How land affects assets">
    <p>
      We don’t usually count the primary residence as an asset. However, if the
      home sits on more than 2 acres of land, the extra land{' '}
      <span className="vads-u-font-style--italic">may</span> count toward the
      the total assets and affect benefits.
    </p>
  </va-additional-info>
);

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['financial-info-land-lot-title']),
    homeAcreageMoreThanTwo: {
      ...yesNoUI(),
      'ui:options': {
        updateSchema: formData => {
          let title = content['financial-info-land-lot-question'];
          if (isRelationshipToVeteran(formData) === 'custodian') {
            title = content['financial-info-land-lot-question-custodian'];
          }
          return {
            title,
          };
        },
      },
    },
    'view:landAffect': {
      'ui:description': LandAffect,
      'ui:options': {
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['homeAcreageMoreThanTwo'],
    properties: {
      homeAcreageMoreThanTwo: yesNoSchema,
      'view:landAffect': {
        type: 'object',
        properties: {},
      },
    },
  },
};
